import React from "react";
import Pagination from "./Pagination";

const UserTables = ({ data, currentPage, totalPages, onPageChange }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-gray-700 text-white rounded-lg">
        <thead>
          <tr className="text-left border-b border-gray-600">
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Email</th>
            <th className="px-4 py-3">Phone</th>
            <th className="px-4 py-3">Status</th>
            {/* <th className="px-4 py-3">Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item.id || index}
                className="border-b border-gray-600 hover:bg-gray-600 transition"
              >
                <td className="px-4 py-3">{item.name}</td>
                <td className="px-4 py-3">{item.email}</td>
                <td className="px-4 py-3">{item.phone}</td>
                <td className="px-4 py-3">
                  <span
                    className={`p-2 rounded ${
                      item.status === "Approved"
                        ? "bg-green-500"
                        : "bg-yellow-500"
                    } text-white`}
                  >
                    {item.status}
                  </span>
                </td>
                {/* <td className="px-4 py-3 flex gap-2">
                  <button className="px-2 py-1 bg-blue-500 rounded hover:bg-blue-600">
                    Edit
                  </button>
                  <button className="px-2 py-1 bg-red-500 rounded hover:bg-red-600">
                    Delete
                  </button>
                </td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-4">
                No data found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="mt-4 flex justify-center">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default UserTables;
